export function buildPreviousAnswerText({ previousAnswer, answer }: { previousAnswer: string, answer: string }) {
    if (!previousAnswer) {
        return ""
    } else {
        return `Original: ${previousAnswer}`
    }
}

export function buildAnswerText({ previousAnswer, answer }: { previousAnswer: string, answer: string }) {
    if (!previousAnswer) {
        return answer ?? ""
    } else if (previousAnswer === answer) {
        return "No change"
    } else {
        return `Revised: ${answer}`
    }
}

